import React from 'react'
import { motion } from "framer-motion"
import service_bg from "../assets/images/services/services-1.jpg"
import heart from "../assets/images/services/heart.png"
import { getServiceDate, getServiceData } from '../utlits/fackData/classData';
import CprForm from '../components/sections/cprForm'
import PageTitle from '../components/common/pageTitle'
import { ScrollRestoration } from 'react-router-dom'
import { zoomIn } from '../utlits/zoomIn'

const CprDetails = () => {
  const cprDate = getServiceDate(1); // Gets CPR details
  const serviceData = getServiceData(1); // Gets complete service data including dates
  
  return (
    <>
      <PageTitle link={"CPR Details"} pageName={"HeartSaver Class Details"} />
      <div className="services-details-area pt-100 pb-75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <motion.div className="image"
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(1)}
                viewport={{ once: true, amount: 0 }}
              >
                <img src={service_bg} alt="CPR HeartSaver Class" />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <h1>HeartSaver Class</h1>
              <h2>$100 | {cprDate}</h2>
              <br />

              <h3>Woodlawn<br />
              1450 Hwy 98 E Columbia, MS 39429</h3>
              <p>Learn to save lives with certified American Heart Association medical training for all ages. This comprehensive CPR certification course will teach you the lifesaving skills needed in emergency situations.</p>
             
              <div className="row">
                              <div className="col-lg-6 col-sm-6">
                                <div className="content-item">
                                  
                                  <p>After you complete the form, you will be taken to our payment page. Your payment is required to reserve your seat immediately.
                                  If you have any questions or concerns please contact us at j5solutionssp@gmail.com. You can also call or text (601)633-1159.
                                  We look forward to training with you.</p>
                                </div>
                              </div>
                              <div className="col-lg-6 col-sm-6">
                                <div className="content-item">
                                  <img src={heart} alt="Aligned Instructor" />
                                </div>
                              </div>
                            </div>
            </div>
          </div>
        </div>
        <div className="services-details-area pt-100 pb-75"> 
          <CprForm serviceData={serviceData} />
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default CprDetails
